import React from 'react';
import NextBaseImage, { type ImageProps } from 'next/image';
import type { PandaSafeHtmlProps } from '../../types/HTMLStyledProps';

export const Image = React.forwardRef<HTMLImageElement, PandaSafeHtmlProps<ImageProps>>((props, ref) => (
  <NextBaseImage ref={ref} {...props} />
));

Image.displayName = 'Image';

export default Image;
